// src/TimesheetView.js

import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import {
    collection,
    query,
    where,
    orderBy,
    onSnapshot,
    Timestamp,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    getDocs,
    getDoc
} from 'firebase/firestore';
import { useUser } from './UserContext';
import { logAction } from './loggingService'; // Per tracciare le modifiche manuali
import moment from 'moment';
import 'moment/locale/it';
import Select from 'react-select'; // Per il selettore utente (manager)
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
import './Timesheet.css'; // Creeremo questo file per gli stili
import { FaEdit, FaTrashAlt, FaPlusCircle, FaCalendarAlt } from 'react-icons/fa'; // Aggiunta FaCalendarAlt
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import it from 'date-fns/locale/it'; // Importa locale italiano per datepicker
import { DiscrepancyModal } from './DiscrepancyModal';
import { ChangeShiftModal } from './Modals';
import { createNotification } from './notificationService';
import { LeaveRequestModal } from './LeaveRequestModal';
registerLocale('it', it); // Registra locale

moment.locale('it');

// --- MODALE PER INSERIMENTO/MODIFICA MANUALE ---
// (Per ora lo mettiamo nello stesso file per semplicità)
const ManualEntryModal = ({ logEntry, onClose, onSave, userId, userName, currentOvertime, initialDate }) => {
    const [entryType, setEntryType] = useState('clock-in');
    const [entryDate, setEntryDate] = useState(moment().format('YYYY-MM-DD'));
    const [entryTime, setEntryTime] = useState(moment().format('HH:mm'));
    const [notes, setNotes] = useState('');
    const [overtimeMinutes, setOvertimeMinutes] = useState(0);

    useEffect(() => {
        if (logEntry) {
            setEntryType(logEntry.type);
            setEntryDate(moment(logEntry.timestamp.toDate()).format('YYYY-MM-DD'));
            setEntryTime(moment(logEntry.timestamp.toDate()).format('HH:mm'));
            setNotes(logEntry.notes || '');
        } else {
            // Reset per nuovo inserimento
            setEntryType('clock-in');
            const defaultDate = initialDate ? moment(initialDate) : moment();
            setEntryDate(defaultDate.format('YYYY-MM-DD'));
            setEntryTime(moment().format('HH:mm'));
            setNotes('');
        }
    if (currentOvertime) {
            const totalMins = (currentOvertime.h || 0) * 60 + (currentOvertime.m || 0);
            setOvertimeMinutes(totalMins);
        } else {
            setOvertimeMinutes(0);
        }
    }, [logEntry, currentOvertime, initialDate]);

    const handleSave = () => {
        if (!entryDate || !entryTime) {
            toast.error("Data e ora sono obbligatorie.");
            return;
        }
        const combinedDateTime = moment(`${entryDate} ${entryTime}`, 'YYYY-MM-DD HH:mm');
        if (!combinedDateTime.isValid()) {
             toast.error("Formato data o ora non valido.");
             return;
        }

        const timestamp = Timestamp.fromDate(combinedDateTime.toDate());

        onSave({
            id: logEntry?.id, // Passa l'ID se stiamo modificando
            userId: logEntry?.userId || userId, // Usa l'ID esistente o quello passato per la creazione
            userName: logEntry?.userName || userName, // Usa il nome esistente o quello passato
            type: entryType,
            timestamp: timestamp,
            shiftDate: combinedDateTime.format('YYYY-MM-DD'),
            notes: notes.trim(),
            isManualEntry: true, // Flag per indicare che è un inserimento/modifica manuale
            newOvertime: {
                h: Math.floor(overtimeMinutes / 60),
                m: overtimeMinutes % 60
            }
        });
    };

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()} style={{ maxWidth: '450px' }}>
                <h3>{logEntry ? 'Modifica Timbratura' : 'Inserimento Manuale'}</h3>
                <div style={{ textAlign: 'left', marginTop: '15px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div className="form-group">
                        <label>Tipo</label>
                        <select value={entryType} onChange={(e) => setEntryType(e.target.value)}>
                            <option value="clock-in">Entrata</option>
                            <option value="clock-out">Uscita</option>
                            <option value="start-break">Inizio Pausa</option>
                            <option value="end-break">Fine Pausa</option>
                        </select>
                    </div>
                    <div className="form-row">
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Data</label>
                            <input type="date" value={entryDate} onChange={(e) => setEntryDate(e.target.value)} />
                        </div>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Ora</label>
                            <input type="time" value={entryTime} onChange={(e) => setEntryTime(e.target.value)} />
                        </div>
                    </div>
                    {/* NUOVO CAMPO STRAORDINARIO (Visibile in questo modale) */}
                    <div className="form-group" style={{padding: '10px', backgroundColor: '#fff3cd', borderRadius: '5px', border: '1px solid #ffeeba'}}>
                        <label style={{color: '#856404'}}>Gestione Straordinario Giornaliero (Minuti Totali)</label>
                        <input 
                            type="number" 
                            min="0" 
                            value={overtimeMinutes} 
                            onChange={(e) => setOvertimeMinutes(parseInt(e.target.value) || 0)}
                            placeholder="Minuti (es. 90 per 1h 30m)"
                        />
                        <small style={{display: 'block', marginTop: '5px', color: '#856404'}}>
                            Attuale: {Math.floor(overtimeMinutes/60)}h {overtimeMinutes%60}m. Modificando questo valore aggiornerai il calendario.
                        </small>
                    </div>
                    <div className="form-group">
                        <label>Note (Obbligatorie per inserimento/modifica manuale)</label>
                        <textarea
                        value={notes || ''}
                        onChange={(e) => setNotes(e.target.value)}
                        rows="3"
                        placeholder="Motivo dell'inserimento/modifica..."
                        required
                    />
                    </div>
                </div>
                <div>
                    <button onClick={handleSave} className="modal-button confirm-button" style={{ marginTop: '20px' }}>Salva</button>
                    <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
};
// --- FINE MODALE ---

const calculateActualDuration = (dayLogs) => {
    let totalWorkMinutes = 0;
    let totalBreakMinutes = 0;
    let lastClockIn = null;
    let lastBreakStart = null;
    let errors = []; // Per segnalare timbrature anomale

    const sortedLogs = [...dayLogs].sort((a, b) => a.timestamp.toDate() - b.timestamp.toDate());

    for (const log of sortedLogs) {
        const logTime = moment(log.timestamp.toDate());

        switch (log.type) {
            case 'clock-in':
                if (lastClockIn === null) {
                    lastClockIn = logTime;
                } else {
                     errors.push(`Doppia Entrata alle ${logTime.format('HH:mm')}`);
                     // Considera l'ultima entrata come valida
                     lastClockIn = logTime;
                }
                if (lastBreakStart !== null) {
                     errors.push(`Entrata durante Pausa alle ${logTime.format('HH:mm')}`);
                     totalBreakMinutes += logTime.diff(lastBreakStart, 'minutes');
                     lastBreakStart = null;
                }
                break;
            case 'clock-out':
                if (lastClockIn !== null) {
                    if (lastBreakStart !== null) {
                         errors.push(`Uscita durante Pausa alle ${logTime.format('HH:mm')}`);
                         totalBreakMinutes += logTime.diff(lastBreakStart, 'minutes');
                         lastBreakStart = null;
                    }
                    totalWorkMinutes += logTime.diff(lastClockIn, 'minutes');
                    lastClockIn = null;
                } else {
                     errors.push(`Uscita senza Entrata alle ${logTime.format('HH:mm')}`);
                }
                break;
            case 'start-break':
                if (lastClockIn !== null && lastBreakStart === null) {
                    lastBreakStart = logTime;
                } else if(lastBreakStart !== null){
                    errors.push(`Doppio Inizio Pausa alle ${logTime.format('HH:mm')}`);
                    // Considera l'ultimo inizio pausa come valido
                    lastBreakStart = logTime;
                } else {
                    errors.push(`Inizio Pausa senza Entrata alle ${logTime.format('HH:mm')}`);
                }
                break;
            case 'end-break':
                if (lastBreakStart !== null) {
                    totalBreakMinutes += logTime.diff(lastBreakStart, 'minutes');
                    lastBreakStart = null;
                } else {
                    errors.push(`Fine Pausa senza Inizio alle ${logTime.format('HH:mm')}`);
                }
                break;
            default: break;
        }
    }

     // Se a fine ciclo l'utente è ancora in pausa o in servizio (timbratura mancante)
     if (lastBreakStart !== null) errors.push("Manca Fine Pausa");
     if (lastClockIn !== null) errors.push("Manca Uscita");


    // Assicurati che i minuti non siano negativi a causa di errori
    totalWorkMinutes = Math.max(0, totalWorkMinutes);
    totalBreakMinutes = Math.max(0, totalBreakMinutes);
    const actualNetMinutes = Math.max(0, totalWorkMinutes - totalBreakMinutes);

    return {
        actualNetMinutes, // Durata netta lavorata
        totalWorkMinutes, // Durata lorda (dalla prima entrata all'ultima uscita nei cicli validi)
        totalBreakMinutes,// Durata totale pause valide
        errors            // Array di stringhe di errore
    };
};

// Funzione Calcolo Durata Prevista (leggermente modificata per usare timeSlots passate)
const calculateExpectedDuration = (user, dayMoment, userTimeSlots, schedulesData) => {
    if (!user || !userTimeSlots) {
        // Valori di default se mancano dati utente
        return { expectedMinutes: 0, shiftDetailsFound: false, shiftName: null, plannedOvertimeMinutes: 0, plannedLeaveMinutes: 0, pauseMinutesPlanned: 0 };
    }

    const dayString = dayMoment.format('YYYY-MM-DD');
    let expectedMinutes = 0;
    let shiftDetailsFound = false;
    let shiftName = null;
    let plannedOvertimeMinutes = 0;
    let plannedLeaveMinutes = 0;
    let pauseMinutesPlanned = 0;
    let baseShiftDuration = 0; // Durata base del turno senza straordinari/permessi

    try {
        // CORRETTO
const plannedShift = schedulesData[dayString]?.[user.id] || schedulesData[dayString]?.[user.name];

        if (plannedShift && plannedShift.name !== 'Ferie' && plannedShift.name !== 'Malattia' && plannedShift.name !== 'CHIUSO') {
            shiftDetailsFound = true;
            shiftName = plannedShift.name; // Salva il nome del turno effettivo

            // --- Calcola Durata Base e Pausa Prevista ---
            if (plannedShift.name === 'Nuovo Orario' && plannedShift.customTime) {
                const start = moment(plannedShift.customTime.start, 'HH:mm');
                const end = moment(plannedShift.customTime.end, 'HH:mm');
                if (start.isValid() && end.isValid() && end.isAfter(start)) {
                    baseShiftDuration = end.diff(start, 'minutes');
                }
                pauseMinutesPlanned = 0; // Assumiamo 0 per custom time
            } else {
                // Gestione nome turno (standard, REC, Sabato, ecc.)
                let shiftNameForLookup = plannedShift.originalName || plannedShift.name;
                // Gestione recupero per turni nominali (Mattina REC, ecc.)
                if (plannedShift.isRecovery && !shiftNameForLookup.endsWith(' REC')) {
                    shiftNameForLookup += ' REC';
                }
                const dayString = dayMoment.format('YYYY-MM-DD');
const timeSlot = userTimeSlots.find(ts => {
    const from = ts.validFrom || "2020-01-01";
    const until = ts.validUntil || "2100-01-01";

    return ts.name === shiftNameForLookup && 
           moment(dayString).isBetween(from, until, 'day', '[]');
});

                if (timeSlot) {
                    const start = moment(timeSlot.startTime, 'HH:mm');
                    const end = moment(timeSlot.endTime, 'HH:mm');
                    if (start.isValid() && end.isValid() && end.isAfter(start)) {
                        baseShiftDuration = end.diff(start, 'minutes'); // Durata lorda da timeslot
                        pauseMinutesPlanned = timeSlot.pauseMinutes || 0; // Pausa da timeslot
                    }
                } else {
                    console.warn(`Timeslot non trovata per ${user.name} - turno '${shiftNameForLookup}' il ${dayString}`);
                    shiftDetailsFound = false; // Non possiamo calcolare senza timeslot
                }
            }
            // --- Fine Calcolo Durata Base ---

            // Calcola Durata Prevista Netta Iniziale (senza considerare ancora straordinari/permessi)
            expectedMinutes = baseShiftDuration - pauseMinutesPlanned;

            // Recupera straordinari/permessi pianificati dallo schedule
            if (plannedShift.overtime && (plannedShift.overtime.h > 0 || plannedShift.overtime.m > 0)) {
                plannedOvertimeMinutes = (plannedShift.overtime.h * 60) + plannedShift.overtime.m;
            }
            if (plannedShift.leave && (plannedShift.leave.h > 0 || plannedShift.leave.m > 0)) {
                plannedLeaveMinutes = (plannedShift.leave.h * 60) + plannedShift.leave.m;
            }

            // === MODIFICA CHIAVE QUI ===
            // Verifica se siamo nel caso speciale "Sabato Straordinario"
            const isSaturdayOvertimeShift = (shiftName === 'Sabato' && plannedOvertimeMinutes > 0);

            // Aggiungi straordinario a 'Previsto' SOLO SE NON è il caso speciale "Sabato Straordinario"
            if (!isSaturdayOvertimeShift) {
                expectedMinutes += plannedOvertimeMinutes; // Comportamento standard: straordinario aumenta il previsto
            }
            // Altrimenti (se è Sabato Straordinario), 'expectedMinutes' rimane la durata base del Sabato,
            // mentre 'plannedOvertimeMinutes' mantiene il valore dello straordinario per mostrarlo a parte.
            // ===========================

            // Sottrai permesso (logica invariata)
            if (plannedLeaveMinutes > 0) {
                // Se il turno base è 'Permesso', il previsto diventa 0
                if (shiftName === 'Permesso') {
                    expectedMinutes = 0;
                } else {
                    // Altrimenti sottrai le ore di permesso dal previsto
                    expectedMinutes -= plannedLeaveMinutes;
                }
            }

            // Assicura che il previsto non sia negativo
            expectedMinutes = Math.max(0, expectedMinutes);

        } else if (plannedShift) {
             // Se il turno è Ferie, Malattia, Chiuso -> Previsto = 0
             shiftDetailsFound = true;
             shiftName = plannedShift.name;
             expectedMinutes = 0;
        }

    } catch (error) {
        console.error("Errore calcolo durata prevista:", error);
        shiftDetailsFound = false; // Errore nel calcolo
    }

    // Restituisce tutti i valori calcolati, inclusi straordinario/permesso separati
    return { expectedMinutes, shiftDetailsFound, shiftName, plannedOvertimeMinutes, plannedLeaveMinutes, pauseMinutesPlanned };
};

// Funzione Helper per formattare i minuti in HH:MM
const formatMinutesToHM = (totalMinutes) => {
    if (totalMinutes === null || totalMinutes === undefined || isNaN(totalMinutes)) return "--:--";
    const sign = totalMinutes < 0 ? "-" : "";
    const absMinutes = Math.abs(totalMinutes);
    const hours = Math.floor(absMinutes / 60);
    const minutes = absMinutes % 60;
    return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

function TimesheetView() {
    const { userProfile } = useUser();
    const permissionLevel = userProfile?.permissions?.shifts || 'none';
    const staffPermission = userProfile?.permissions?.staff || 'none';
   const isManager = 
        permissionLevel === 'completo' || 
        permissionLevel === 'semi-completo' || 
        staffPermission === 'completo' || // Opzionale: se chi gestisce staff può anche vedere timbrature
        userProfile?.role === 'Super Admin';
        
    const [staffList, setStaffList] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedUserData, setSelectedUserData] = useState(null); // Stato per dati utente completo
    const [selectedMonthMoment, setSelectedMonthMoment] = useState(moment());
    const [timelogs, setTimelogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingLog, setEditingLog] = useState(null);
    const [viewMode, setViewMode] = useState('day');
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [modalDataExtra, setModalDataExtra] = useState({});
    // --- NUOVO STATO PER SCHEDULES ---
    const [schedulesData, setSchedulesData] = useState({});

    const TOLERANCE_MINUTES = 30; // Tolleranza (come in ClockInOutCard)

    const [isDiscrepancyModalOpen, setIsDiscrepancyModalOpen] = useState(false);
    const [discrepancyData, setDiscrepancyData] = useState({ difference: 0, dayString: '', user: null });
    const [isOvertimeModalOpen, setIsOvertimeModalOpen] = useState(false);
    const [isLeaveModalOpen, setIsLeaveModalOpen] = useState(false);
    const [modalDefaultDate, setModalDefaultDate] = useState(null);

    // Carica la lista dello staff se l'utente è un manager
    useEffect(() => {
    if (isManager && userProfile && userProfile.centerId) { // <-- MODIFICA QUI (aggiungi centerId)
        const fetchStaff = async () => {
             const staffSnapshot = await getDocs(collection(db, 'centers', userProfile.centerId, "staff")); // <-- MODIFICA PERCORSO
                 // Salva sia le opzioni per il select che i dati completi
                 const allStaffData = staffSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                 const staffOptions = allStaffData
                     .map(staff => ({ value: staff.id, label: staff.name })) // Usa name corretto qui
                     .sort((a, b) => a.label.localeCompare(b.label));
                 setStaffList(staffOptions);
                 // Potremmo caricare i dati completi solo quando un utente viene selezionato
            };
            fetchStaff();
        } else {
            setSelectedUser({ value: userProfile.uid, label: userProfile.name });
            setSelectedUserData(userProfile); // Imposta subito i dati per utente non manager
        }
    }, [isManager, userProfile]);

    // Effetto per caricare i dati completi dell'utente selezionato (se manager)
    useEffect(() => {
    const fetchSelectedUserData = async () => {
        if (isManager && selectedUser && userProfile.centerId) { // <-- MODIFICA QUI (aggiungi centerId)
            const userDocRef = doc(db, 'centers', userProfile.centerId, 'staff', selectedUser.value); // <-- MODIFICA PERCORSO
                const docSnap = await getDoc(userDocRef);
                if (docSnap.exists()) {
                    setSelectedUserData({ id: docSnap.id, ...docSnap.data() });
                } else {
                    setSelectedUserData(null); // Utente non trovato?
                }
            } else if (!isManager) {
                 setSelectedUserData(userProfile); // Assicura che sia impostato per non-manager
            } else {
                 setSelectedUserData(null); // Reset se nessun utente selezionato
            }
        };
        fetchSelectedUserData();
    }, [selectedUser, isManager, userProfile]);


    // --- useEffect CARICAMENTO TIMBRATURE E SCHEDULES ---
    useEffect(() => {
        console.log("useEffect triggered. selectedUser:", selectedUser, "selectedMonthMoment:", selectedMonthMoment?.format('YYYY-MM')); // Debug

        // Controllo primario: userId deve essere una stringa valida
        const currentUserId = selectedUser?.value;
        if (!currentUserId || typeof currentUserId !== 'string' || !userProfile.centerId) { // <-- MODIFICA QUI
        console.log("No valid selected user ID or centerId, clearing data."); // <-- MODIFICA LOG
        setTimelogs([]);
        setSchedulesData({});
        setIsLoading(false); // Imposta isLoading a false qui!
        return () => {}; // Ritorna cleanup vuoto
    }
    const centerId = userProfile.centerId; // <-- AGGIUNGI centerId locale

        setIsLoading(true);
        const startOfMonth = selectedMonthMoment.clone().startOf('month').toDate();
        const endOfMonth = selectedMonthMoment.clone().endOf('month').toDate();
        const monthString = selectedMonthMoment.format('YYYY-MM');

        console.log("User selected:", currentUserId, "Month:", monthString); // Debug

        let unsubscribeLogs = () => {};
        let unsubscribeSchedules = () => {};
        let listenersAttached = false; // Flag per gestire il caricamento

        try {
            // --- Listener per Timelogs ---
            const timelogsCollectionRef = collection(db, 'centers', centerId, 'timelogs'); // <-- MODIFICA PERCORSO
            const qLogs = query(
                timelogsCollectionRef,
                where('userId', '==', currentUserId), // Usa currentUserId (garantito stringa)
                where('timestamp', '>=', startOfMonth),
                where('timestamp', '<=', endOfMonth),
                orderBy('timestamp', 'asc')
            );
            console.log("qLogs object:", qLogs); // Debug

            unsubscribeLogs = onSnapshot(qLogs, (snapshot) => {
                const logs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                console.log(`Logs snapshot received: ${logs.length} docs`); // Debug
                setTimelogs(logs);
                // Non impostare isLoading qui, aspetta anche schedules
            }, (error) => {
                console.error("Errore snapshot timelogs:", error);
                toast.error("Errore nel caricamento delle timbrature.");
                setTimelogs([]); // Pulisci i log in caso di errore
                setIsLoading(false);
            });

            // --- Listener per Schedules ---
            const scheduleDocRef = doc(db, 'centers', centerId, 'schedules', monthString); // <-- MODIFICA PERCORSO
            console.log("scheduleDocRef object:", scheduleDocRef); // Debug

            unsubscribeSchedules = onSnapshot(scheduleDocRef, (docSnap) => {
                console.log(`Schedules snapshot received for ${monthString}. Exists: ${docSnap.exists()}`); // Debug
                if (docSnap.exists() && docSnap.data().schedule) {
                    try {
                        setSchedulesData(JSON.parse(docSnap.data().schedule));
                    } catch (e) {
                        console.error("Errore parsing schedule JSON:", e);
                        setSchedulesData({});
                    }
                } else {
                    setSchedulesData({});
                }
                setIsLoading(false); // FINE CARICAMENTO (dopo aver ricevuto schedules)
                listenersAttached = true; // Segna che i listener sono attivi
            }, (error) => {
                 console.error("Errore snapshot schedules:", error);
                 setSchedulesData({});
                 setIsLoading(false); // FINE CARICAMENTO (anche in caso di errore)
            });

        } catch (error) {
             console.error("Error setting up listeners:", error);
             toast.error("Errore nell'impostazione dei listener.");
             setIsLoading(false); // Assicura che isLoading si fermi
        }

        // Funzione di pulizia
        return () => {
            console.log("Cleaning up listeners for", currentUserId, monthString); // Debug
            unsubscribeLogs();
            unsubscribeSchedules();
        };

    // Dipendenze: si riesegue solo se l'ID utente cambia o il mese cambia
    }, [selectedUser, selectedMonthMoment, userProfile.centerId]); // Usa valori stabili come dipendenze
    // --- FINE useEffect CARICAMENTO ---

    // Funzioni per cambiare mese
    const goToPreviousMonth = () => setSelectedMonthMoment(prev => prev.clone().subtract(1, 'month'));
    const goToNextMonth = () => setSelectedMonthMoment(prev => prev.clone().add(1, 'month'));
    const goToCurrentMonth = () => setSelectedMonthMoment(moment());

    // --- NUOVA FUNZIONE PER CAMBIARE GIORNO DAL DATEPICKER ---
    const handleDateChange = (date) => {
        setSelectedDate(date);
        // Imposta automaticamente la vista giornaliera quando si seleziona una data
        setViewMode('day');
        // Aggiorna anche il mese visualizzato se necessario
        if (!moment(date).isSame(selectedMonthMoment, 'month')) {
            setSelectedMonthMoment(moment(date));
        }
    };
    // --- FUNZIONI CRUD PER TIMBRATURE MANUALI (SOLO MANAGER) ---
    const handleOpenModal = (log = null, dateOverride = null) => {
        if (!isManager && log?.userId !== userProfile.uid) return;
        
        // Recupera lo straordinario attuale per il giorno del log (o oggi se nuovo)
        let currentOvertime = { h: 0, m: 0 };
        const dateKey = log ? moment(log.timestamp.toDate()).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        
        // Cerca nello schedulesData (caricato dall'useEffect principale)
        // Nota: selectedUser.value è l'ID dell'utente visualizzato
        const userIdTarget = selectedUser?.value; 
        if (schedulesData[dateKey] && schedulesData[dateKey][userIdTarget]) {
            currentOvertime = schedulesData[dateKey][userIdTarget].overtime || { h: 0, m: 0 };
        }

        setEditingLog(log);
        // Salviamo i dati extra nello stato del modale o passiamoli diversamente
        // Per semplicità, usiamo un ref o estendiamo editingLog, ma qui passo via props nel render
        setModalDataExtra({ currentOvertime }); // <--- Creiamo questo stato o usiamone uno esistente
        setModalDefaultDate(dateOverride);
        setIsModalOpen(true);
    };

    const handleSaveManualEntry = async (logData) => {
        if (!isManager || !userProfile.centerId) return;
        const centerId = userProfile.centerId;
        const { id, newOvertime, ...dataToSave } = logData; // Estrai newOvertime

        if (!dataToSave.notes) {
            toast.error("Le note sono obbligatorie.");
            return;
        }

        try {
            // 1. Salva/Aggiorna Timelog (Invariato)
            if (id) {
                const logRef = doc(db, 'centers', centerId, 'timelogs', id);
                await updateDoc(logRef, dataToSave);
                toast.success("Timbratura aggiornata.");
            } else {
                await addDoc(collection(db, 'centers', centerId, 'timelogs'), dataToSave);
                toast.success("Timbratura inserita.");
            }

            // 2. Aggiorna Straordinario in Schedule (NUOVO)
            const dayStr = dataToSave.shiftDate;
            const monthString = moment(dayStr).format('YYYY-MM');
            const scheduleDocRef = doc(db, 'centers', centerId, 'schedules', monthString);
            
            // Leggi, aggiorna, scrivi (Pattern ottimistico o transazione)
            const scheduleSnap = await getDoc(scheduleDocRef);
            if (scheduleSnap.exists()) {
                const scheduleDataRemote = JSON.parse(scheduleSnap.data().schedule || '{}');
                const userId = dataToSave.userId;
                
                if (!scheduleDataRemote[dayStr]) scheduleDataRemote[dayStr] = {};
                if (!scheduleDataRemote[dayStr][userId]) {
                    // Se non c'era turno, crealo placeholder per ospitare lo straordinario
                    scheduleDataRemote[dayStr][userId] = { name: 'Sconosciuto', overtime: newOvertime };
                } else {
                    // Aggiorna solo overtime
                    scheduleDataRemote[dayStr][userId].overtime = newOvertime;
                }
                
                await updateDoc(scheduleDocRef, { schedule: JSON.stringify(scheduleDataRemote) });
            }

            // 3. Log e Notifica all'Utente (NUOVO)
            await logAction(userProfile, `ha modificato manuale timbratura/straordinario per ${dataToSave.userName}`);
            
            if (dataToSave.userId !== userProfile.uid) {
                createNotification(
                    dataToSave.userId,
                    userProfile,
                    `ha modificato una tua timbratura o straordinario del ${moment(dayStr).format('DD/MM')}. Note: ${dataToSave.notes}`,
                    '/timbrature'
                );
            }

            setIsModalOpen(false);
            setEditingLog(null);
            
            // Ricalcolo discrepanza (Invariato)
            if (selectedUserData) {
                await checkManualDiscrepancy(selectedUserData, dataToSave.timestamp);
            }

        } catch (error) {
            console.error("Errore salvataggio:", error);
            toast.error("Errore durante il salvataggio.");
        }
    };

    const handleDeleteLog = async (log) => {
    if (!isManager || !userProfile.centerId) return; // <-- MODIFICA QUI
    const centerId = userProfile.centerId; // <-- RECUPERA centerId

    if (window.confirm(`Sei sicuro di voler eliminare la timbratura ${log.type} di ${log.userName} del ${moment(log.timestamp.toDate()).format('DD/MM HH:mm')}?`)) {
        try {
            const logRef = doc(db, 'centers', centerId, 'timelogs', log.id); // <-- MODIFICA PERCORSO
                await deleteDoc(logRef);
                await logAction(userProfile, `ha eliminato una timbratura (${log.type}) per ${log.userName} del ${moment(log.timestamp.toDate()).format('DD/MM HH:mm')}`); //
                toast.warn("Timbratura eliminata.");
                // Aggiornamento automatico via onSnapshot
            } catch (error) {
                console.error("Errore eliminazione timbratura:", error);
                toast.error("Errore durante l'eliminazione.");
            }
        }
    };
    // --- FINE FUNZIONI CRUD ---

    // --- INIZIO MODIFICA: Aggiungi funzioni per gestire la discrepanza ---

    // Chiamata quando si ignora la discrepanza
    const handleDiscrepancyIgnore = () => {
        setIsDiscrepancyModalOpen(false);
    };

    // Chiamata per aprire il modale straordinario
    const handleDiscrepancyAddOvertime = () => {
        setIsDiscrepancyModalOpen(false);
        setIsOvertimeModalOpen(true);
    };

    // Chiamata per aprire il modale permesso
    const handleDiscrepancyRequestLeave = () => {
        setIsDiscrepancyModalOpen(false);
        setIsLeaveModalOpen(true);
    };

    // Chiamata da LeaveRequestModal quando la richiesta è inviata
    const handleLeaveRequestSubmitted = () => {
         setIsLeaveModalOpen(false);
    };

    // Salva lo straordinario nello schedule (adattato da ClockInOutCard.js)
    const handleSaveOvertime = async (shiftUpdateData) => {
        const { dayStr, overtime } = shiftUpdateData;
        const user = discrepancyData.user || userProfile; // Recupera l'utente dallo stato

        if (!user) {
             toast.error("Errore: utente non trovato per salvare lo straordinario.");
             setIsOvertimeModalOpen(false);
             return;
        }

        const monthString = moment(dayStr, 'YYYY-MM-DD').format('YYYY-MM');
        if (!user.centerId) return { expectedMinutes: 0, shiftDetailsFound: false }; // Guard
        const scheduleDocRef = doc(db, 'centers', user.centerId, 'schedules', monthString); // <-- MODIFICA PERCORSO

        try {
            const scheduleSnap = await getDoc(scheduleDocRef);
            if (!scheduleSnap.exists()) {
                toast.error("Documento turni non trovato per questo mese.");
                setIsOvertimeModalOpen(false);
                return;
            }
            const scheduleData = JSON.parse(scheduleSnap.data().schedule || '{}');
            if (!scheduleData[dayStr]) scheduleData[dayStr] = {};
            if (!scheduleData[dayStr][user.name]) scheduleData[dayStr][user.name] = { name: 'Sconosciuto' };

            scheduleData[dayStr][user.name].overtime = overtime;

            await updateDoc(scheduleDocRef, { schedule: JSON.stringify(scheduleData) });

            if (!isManager) { // Se chi salva NON è un manager (è un utente normale)
             const staffRef = collection(db, 'centers', userProfile.centerId, 'staff');
             // Trova tutti i manager
             const qManager = query(staffRef, where("permissions.shifts", "in", ["completo", "semi-completo"]));
             const managersSnap = await getDocs(qManager);
             
             managersSnap.forEach(mgr => {
                 if (mgr.id !== user.uid) {
                     createNotification(
                        mgr.id,
                        user, // Mittente (l'utente)
                        `ha registrato ${overtime.h}h ${overtime.m}m di straordinario per il ${moment(dayStr).format('DD/MM')}.`,
                        '/turni' // O /timbrature
                     );
                 }
             });
        }

            await logAction(userProfile, `ha registrato ${overtime.h}h ${overtime.m}m di straordinario per ${user.name} il ${moment(dayStr).format('DD/MM')}`);
            toast.success("Straordinario registrato nel turno.");
            setIsOvertimeModalOpen(false);
            // onSnapshot aggiornerà schedulesData
        } catch (error) {
             console.error("Errore salvataggio straordinario:", error);
             toast.error("Errore durante la registrazione dello straordinario.");
        }
    };

    // Funzione principale che controlla la discrepanza dopo un salvataggio manuale
    const checkManualDiscrepancy = async (userForCheck, savedLogTimestamp) => {
        if (!userForCheck || !userForCheck.includeInShifts) {
            console.log("Controllo durata saltato: utente non incluso nei turni.");
            return;
        }

        const dayMoment = moment(savedLogTimestamp.toDate());
        const dayString = dayMoment.format('YYYY-MM-DD');

        // 1. Calcola Durata Prevista (usando la funzione già presente)
        const { expectedMinutes, shiftDetailsFound } = calculateExpectedDuration(
            userForCheck,
            dayMoment,
            userForCheck.timeSlots,
            schedulesData
        );

        if (!shiftDetailsFound) {
             console.log("Controllo durata saltato: nessun turno/timeslot trovato.");
             return;
        }

        // 2. Ricarica TUTTI i log aggiornati per quel giorno (fondamentale)
        const startOfDay = dayMoment.startOf('day').toDate();
    const endOfDay = dayMoment.endOf('day').toDate();

    if (!userForCheck.centerId) { // <-- AGGIUNGI GUARD
        console.error("Errore: centerId non disponibile per l'utente controllato.");
        return;
    }
    const centerIdForCheck = userForCheck.centerId;

    const logsQuery = query(
        collection(db, 'centers', centerIdForCheck, 'timelogs'), // <-- MODIFICA PERCORSO
        where('userId', '==', userForCheck.id),
        where('timestamp', '>=', startOfDay),
            where('timestamp', '<=', endOfDay),
            orderBy('timestamp', 'asc')
        );
        const logsSnapshot = await getDocs(logsQuery);
        const dayLogs = logsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));

        const hasClockIn = dayLogs.some(log => log.type === 'clock-in');
        const hasClockOut = dayLogs.some(log => log.type === 'clock-out');
        
        // Esegui controllo solo se la giornata è "completa"
        if (!hasClockIn || !hasClockOut) {
             console.log("Controllo durata saltato: timbrature incomplete.");
             return;
        }

        // 3. Calcola Durata Effettiva (usando la funzione già presente)
        const { actualNetMinutes } = calculateActualDuration(dayLogs);

        // 4. Confronta e apri il modale se necessario
        const difference = actualNetMinutes - expectedMinutes;
        console.log(`Confronto Durata (Manuale): Effettiva=${actualNetMinutes}min, Prevista=${expectedMinutes}min, Diff=${difference}min`);

        // Uso TOLERANCE_MINUTES (15) per coerenza con ClockInOutCard
        if (Math.abs(difference) > TOLERANCE_MINUTES) {
            setDiscrepancyData({
                difference: difference,
                dayString: dayString,
                user: userForCheck // Salva l'utente per i modali successivi
            });
            setIsDiscrepancyModalOpen(true);
        } else {
            console.log("Nessuna discrepanza significativa rilevata.");
        }
    };
    // --- FINE MODIFICA ---


    const getFilteredAndGroupedLogs = () => {
        if (viewMode === 'day') {
            const dayStr = moment(selectedDate).format('YYYY-MM-DD');
            const logsForDay = timelogs.filter(log => moment(log.timestamp.toDate()).isSame(selectedDate, 'day'));
            return { [dayStr]: logsForDay }; // Ritorna oggetto con una sola chiave per coerenza
        } else { // 'month'
            const grouped = {};
            timelogs.forEach(log => {
                const day = moment(log.timestamp.toDate()).format('YYYY-MM-DD');
                if (!grouped[day]) {
                    grouped[day] = [];
                }
                grouped[day].push(log);
            });
            return grouped;
        }
    };

    const groupedTimelogs = getFilteredAndGroupedLogs();
    // Ordina i giorni (o il singolo giorno)
    const sortedDays = Object.keys(groupedTimelogs).sort((a, b) => b.localeCompare(a)); // Dal più recente
const dailyCalculations = React.useMemo(() => {
        console.log("Ricalcolo dailyCalculations..."); // Debug
        const calculations = {};
        // Esegui solo se abbiamo i dati dell'utente (incluso timeSlots)
        if (selectedUserData && selectedUserData.timeSlots) {
            sortedDays.forEach(dayStr => {
                const dayMoment = moment(dayStr);
                const dayLogs = groupedTimelogs[dayStr] || [];

                // --- Calcola Durata Prevista (ora sincrono) ---
                const {
                    expectedMinutes,
                    shiftDetailsFound,
                    shiftName,
                    plannedOvertimeMinutes,
                    plannedLeaveMinutes,
                    pauseMinutesPlanned
                } = calculateExpectedDuration( // Chiamata diretta
                    selectedUserData,
                    dayMoment,
                    selectedUserData.timeSlots, // Passa timeSlots da selectedUserData
                    schedulesData
                 );

                // --- Calcola Durata Effettiva (già sincrono) ---
                const { actualNetMinutes, totalBreakMinutes, errors } = calculateActualDuration(dayLogs);

                // --- Calcola Differenza ---
                const difference = (shiftDetailsFound && dayLogs.length > 0) // Calcola solo se c'è previsto E almeno una timbratura
                                   ? actualNetMinutes - expectedMinutes
                                   : null;

                // --- Popola l'oggetto per il giorno ---
                calculations[dayStr] = {
                    actualNet: dayLogs.length > 0 ? formatMinutesToHM(actualNetMinutes) : '--:--', // Mostra solo se ci sono timbrature
                    breaks: dayLogs.length > 0 ? formatMinutesToHM(totalBreakMinutes) : '--:--', // Mostra solo se ci sono timbrature
                    expectedNet: shiftDetailsFound ? formatMinutesToHM(expectedMinutes) : '--:--', // Mostra sempre se turno trovato
                    difference: difference !== null ? formatMinutesToHM(difference) : '--:--',
                    differenceRaw: difference,
                    shiftName: shiftName || '--', // Mostra sempre se turno trovato
                    plannedOvertime: formatMinutesToHM(plannedOvertimeMinutes), // Mostra sempre
                    plannedLeave: formatMinutesToHM(plannedLeaveMinutes), // Mostra sempre
                    errors: errors,
                    pausePlanned: formatMinutesToHM(pauseMinutesPlanned) // Mostra sempre
                };
            });
        }
        console.log("dailyCalculations calcolate:", calculations); // Debug
        return calculations;
    // Dipendenze: ricalcola se cambiano timbrature, schedules, utente selezionato o giorni ordinati
    }, [schedulesData, selectedUserData, sortedDays, groupedTimelogs]);// Aggiunto groupedTimelogs
    // --- FINE CALCOLO DATI GIORNALIERI ---


    const showResults = !isLoading && selectedUser && (viewMode === 'month' ? timelogs.length > 0 : (groupedTimelogs[moment(selectedDate).format('YYYY-MM-DD')]?.length > 0));
    const showNoResultsMessage = !isLoading && selectedUser && !showResults;
    

    return (
        <div className="timesheet-container">
             {isModalOpen && (
                 <ManualEntryModal
                     logEntry={editingLog}
                     onClose={() => setIsModalOpen(false)}
                     onSave={handleSaveManualEntry}
                     userId={selectedUser?.value}
                     userName={selectedUser?.label}
                     currentOvertime={modalDataExtra.currentOvertime} // <-- Passa la prop
                     initialDate={modalDefaultDate}
                 />
             )}
             {/* --- INIZIO MODIFICA: Aggiungi i 3 modali per la discrepanza --- */}
            {isDiscrepancyModalOpen && (
                <DiscrepancyModal
                    isOpen={isDiscrepancyModalOpen}
                    onClose={handleDiscrepancyIgnore}
                    timeDifferenceMinutes={discrepancyData.difference}
                    isManager={isManager} // È sempre un manager in questa vista
                    onAddOvertime={handleDiscrepancyAddOvertime}
                    onRequestLeave={handleDiscrepancyRequestLeave}
                />
            )}

            {isOvertimeModalOpen && (
                 <ChangeShiftModal
                     modalData={{
                         person: discrepancyData.user?.name, // Nome utente
                         dayStr: discrepancyData.dayString, // Giorno
                         shiftData: {
                             name: 'Straordinario',
                             overtime: { // Precompila ore
                                h: Math.floor(discrepancyData.difference / 60),
                                m: discrepancyData.difference % 60
                             }
                         }
                     }}
                     onConfirm={handleSaveOvertime} // Funzione creata sopra
                     onClose={() => setIsOvertimeModalOpen(false)}
                     availableShifts={[]} // Non servono opzioni di turno qui
                 />
            )}

            {isLeaveModalOpen && (
                 <LeaveRequestModal
                     onClose={() => setIsLeaveModalOpen(false)}
                     onSubmit={handleLeaveRequestSubmitted} // Funzione creata sopra
                     personId={discrepancyData.user?.id} // ID utente
                     personName={discrepancyData.user?.name} // Nome utente
                     personProfileData={discrepancyData.user} // Profilo completo
                     selectedDate={discrepancyData.dayString} // Giorno
                     leaveType="Permesso" // Forza tipo
                     leaveHours={{ // Precompila ore
                         h: Math.floor(Math.abs(discrepancyData.difference) / 60),
                         m: Math.abs(discrepancyData.difference) % 60
                     }}
                     effectivePermissionLevel={userProfile.permissions?.leaves || 'none'}
                 />
             )}
            {/* --- FINE MODIFICA --- */}
            {/* --- CONTROLLI RIORGANIZZATI --- */}
            <div className="timesheet-controls-grid">

                {/* Colonna Sinistra: Navigazione Mese e Giorno */}
                <div className="controls-col-left">
                    <div className="month-navigation">
                        <button onClick={goToPreviousMonth} disabled={isLoading} title="Mese precedente">‹</button>
                        <span className="month-display" onClick={goToCurrentMonth} title="Vai al mese corrente" style={{cursor: 'pointer'}}>
                            {selectedMonthMoment.format('MMMM YYYY')}
                        </span>
                        <button onClick={goToNextMonth} disabled={isLoading} title="Mese successivo">›</button>
                    </div>
                    <div className="day-selector">
                        <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            locale="it"
                            customInput={ // Pulsante personalizzato con icona
                                <button className="datepicker-button" disabled={isLoading}>
                                    <FaCalendarAlt /> {moment(selectedDate).format('DD/MM/YYYY')}
                                </button>
                            }
                            popperPlacement="bottom-start"
                        />
                    </div>
                </div>

                {/* Colonna Centrale: Selettore Vista */}
                 <div className="controls-col-center">
                      <div className="view-mode-toggle">
                          <button
                              onClick={() => setViewMode('day')}
                              className={viewMode === 'day' ? 'active' : ''}
                              disabled={isLoading}
                           >Vista Giorno</button>
                          <button
                              onClick={() => setViewMode('month')}
                              className={viewMode === 'month' ? 'active' : ''}
                              disabled={isLoading}
                           >Vista Mese</button>
                      </div>
                 </div>

                {/* Colonna Destra: Selettore Utente (solo Manager) */}
                {isManager && (
                    <div className="controls-col-right">
                        <Select
                            options={staffList}
                            value={selectedUser}
                            onChange={setSelectedUser}
                            placeholder="Seleziona dipendente..."
                            isClearable
                            className="react-select-container user-select-instance" // Aggiunta classe specifica
                            classNamePrefix="react-select"
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            menuPortalTarget={document.body}
                            isDisabled={isLoading}
                        />
                         {isManager && selectedUser && (
                              <button
                                 className="add-manual-btn"
                                 onClick={() => handleOpenModal(null, moment(selectedDate).format('YYYY-MM-DD'))}
                                 title="Aggiungi Timbratura Manuale"
                                 disabled={isLoading}
                              >
                                  <FaPlusCircle /> Aggiungi
                              </button>
                         )}
                    </div>
                )}
            </div>
            {/* --- FINE CONTROLLI RIORGANIZZATI --- */}


            {/* --- VISUALIZZAZIONE RISULTATI --- */}
            {isLoading && <p className="loading-text">Caricamento timbrature...</p>}

             {!isLoading && !selectedUser && isManager && (
                 <p className="info-text">Seleziona un utente per visualizzare le timbrature.</p>
             )}

            {/* Messaggio "Nessun risultato" */}
            {showNoResultsMessage && (
                <p className="info-text">
                    Nessuna timbratura trovata per {selectedUser.label}
                    {viewMode === 'day' ? ` il ${moment(selectedDate).format('DD/MM/YYYY')}` : ` nel mese selezionato`}.
                </p>
            )}

            {/* Lista timbrature (mostrata se showResults è true) */}
            {showResults && (
                <div className="timelogs-list">
                    {/* --- INIZIO BLOCCO JSX MODIFICATO --- */}
                    {sortedDays.map(day => {
                        const calcs = dailyCalculations[day] || {};
                        const errors = calcs.errors || [];
                        const hasErrors = errors.length > 0;
                        const isMissingClockOut = errors.includes("Manca Uscita");
                        const isMissingClockIn = !groupedTimelogs[day]?.some(l => l.type === 'clock-in'); // Verifica se manca entrata
                        const hasCriticalErrors = hasErrors && !(isMissingClockOut && errors.length === 1); // Errore critico se non è *solo* uscita mancante

                        // Determina se mostrare placeholder:
                        // Mostra placeholder per Lavorato/Diff se manca Uscita O se manca Entrata O se il calcolo differenza è null
                        const showActualPlaceholder = isMissingClockOut || isMissingClockIn || calcs.differenceRaw === null;
                        // Mostra placeholder per Pausa Eff. solo se mancano timbrature di pausa o entrata/uscita
                        const showBreakPlaceholder = !(groupedTimelogs[day]?.some(l => l.type === 'start-break' && groupedTimelogs[day]?.some(l2 => l2.type === 'end-break'))) || isMissingClockIn ;


                        const differenceClass = calcs.differenceRaw === null ? '' :
                                                calcs.differenceRaw > 15 ? 'difference-positive' :
                                                calcs.differenceRaw < -15 ? 'difference-negative' : '';

                        return (
                            // Aggiunta classe has-critical-errors
                            <div key={day} className={`timelog-day-group ${hasErrors ? 'day-with-errors' : ''} ${hasCriticalErrors ? 'has-critical-errors' : ''}`}>
                                <div className="day-header">
                                    <h3>{moment(day).format('dddd D MMMM YYYY')}</h3>
                                    <div className="day-summary">
                                        <span>Turno: <strong>{calcs.shiftName || '--'}</strong></span>
                                        <span>Previsto: <strong>{calcs.expectedNet || '--:--'}</strong></span>
                                        {calcs.pausePlanned && calcs.pausePlanned !== '00:00' && <span>Pausa Prev.: <strong>{calcs.pausePlanned}</strong></span>}
                                        {/* Logica placeholder aggiornata */}
                                        <span>Lavorato: <strong>{showActualPlaceholder ? '--:--' : (calcs.actualNet || '--:--')}</strong></span>
                                        <span>Pausa Eff.: <strong>{showBreakPlaceholder ? '--:--' : (calcs.breaks || '--:--')}</strong></span>
                                        <span className={differenceClass}>Diff.: <strong>{showActualPlaceholder ? '--:--' : (calcs.difference || '--:--')}</strong></span>
                                        {/* ... (indicatori Str/Perm Pianif.) ... */}
                                        {calcs.plannedOvertime && calcs.plannedOvertime !== '00:00' && <span className="planned-indicator overtime">Str. Pianif.: <strong>{calcs.plannedOvertime}</strong></span>}
                                        {calcs.plannedLeave && calcs.plannedLeave !== '00:00' && <span className="planned-indicator leave">Perm. Pianif.: <strong>{calcs.plannedLeave}</strong></span>}

                                        {/* Mostra errore critico */}
                                        {hasCriticalErrors && (
                                            <span className="timelog-errors" title={errors.join('\n')}>⚠️ Errori Timbratura!</span>
                                        )}
                                         {/* Mostra indicatore uscita mancante (se è l'unico problema) */}
                                         {isMissingClockOut && !hasCriticalErrors && (
                                            <span className="timelog-ongoing" title="Timbratura di uscita mancante">⚪ Uscita mancante</span>
                                         )}
                                          {/* Mostra indicatore entrata mancante (se è l'unico problema e non manca anche uscita)*/}
                                          {isMissingClockIn && !isMissingClockOut && !hasCriticalErrors && (
                                            <span className="timelog-ongoing" title="Timbratura di entrata mancante">⚪ Entrata mancante</span>
                                          )}

                                    </div>
                                </div>
                                <ul>
                                {/* Mappa le timbrature del giorno */}
                                {groupedTimelogs[day].map(log => (
                                    <li key={log.id} className={`timelog-entry type-${log.type} ${log.isManualEntry ? 'manual-entry' : ''}`}>
                                        <span className="log-time">{moment(log.timestamp.toDate()).format('HH:mm:ss')}</span>
                                        <span className="log-type">
                                            {log.type === 'clock-in' ? 'Entrata' : log.type === 'clock-out' ? 'Uscita' : log.type === 'start-break' ? 'Inizio Pausa' : log.type === 'end-break' ? 'Fine Pausa' : log.type}
                                            {log.isManualEntry && <span className="manual-indicator" title={`Inserito/Modificato da manager. Note: ${log.notes || 'N/D'}`}> (M)</span>}
                                        </span>
                                        {(log.isManualEntry || log.notes) && <span className="log-notes">Nota: {log.notes || 'N/D'}</span>}
                                        {isManager && (
                                            <div className="log-actions">
                                                <button onClick={() => handleOpenModal(log)} title="Modifica"><FaEdit /></button>
                                                <button onClick={() => handleDeleteLog(log)} title="Elimina"><FaTrashAlt /></button>
                                            </div>
                                        )}
                                    </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            )}
           <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
}

export default TimesheetView;